/**
 * AppContext — provides shared app data to all page components.
 *
 * app.jsx wraps its content in <AppProvider value={...}>.
 * Pages call useApp() to access the data.
 *
 * This replaces the pageProps prop-drilling pattern from Phase 3.
 */
import { createContext } from "react";

export const AppContext = createContext(null);
